'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = UIHeader;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _HeadingConstants = require('../text/HeadingConstants');

var _UIButtonWrapper = require('./UIButtonWrapper');

var _UIButtonWrapper2 = _interopRequireDefault(_UIButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// 100% arbitrary cutoff for widthConstrained mode
var CONSTRAINED_TITLE_WIDTH = 544;

var pseudoBorderMixin = (0, _styledComponents.css)(['&::after{content:\' \';position:absolute;left:', ';bottom:0;width:calc(100% - ', ' * 2);height:1px;background-color:', ';}'], _sizes.LAYOUT_PADDING_X, _sizes.LAYOUT_PADDING_X, _theme.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR);

var Outer = _styledComponents2.default.header.withConfig({
  displayName: 'UIHeader__Outer'
})(['display:flex;position:relative;flex-direction:column;margin-bottom:', ';padding-bottom:', ';padding-left:', ';padding-right:', ';padding-top:', ';', ';'], function (_ref) {
  var condensed = _ref.condensed;
  return condensed ? '0' : _sizes.LAYOUT_MAIN_PADDING_TOP;
}, function (_ref2) {
  var tabs = _ref2.tabs;
  return tabs ? '0' : _sizes.HEADER_PADDING_BOTTOM;
}, _sizes.LAYOUT_PADDING_X, _sizes.LAYOUT_PADDING_X, function (_ref3) {
  var breadcrumbs = _ref3.breadcrumbs;
  return breadcrumbs ? '0' : _sizes.HEADER_PADDING_TOP;
}, function (_ref4) {
  var condensed = _ref4.condensed,
      fullWidth = _ref4.fullWidth,
      tabs = _ref4.tabs;

  if (condensed || tabs) return null;
  return fullWidth ? 'border-bottom: 1px solid ' + _theme.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR : pseudoBorderMixin;
});

var Inner = _styledComponents2.default.div.withConfig({
  displayName: 'UIHeader__Inner'
})(['display:flex;align-items:center;flex-wrap:wrap;min-height:', ';padding-bottom:', ';'], _sizes.INPUT_DEFAULT_HEIGHT, function (_ref5) {
  var tabs = _ref5.tabs;
  return tabs && '8px';
});

var Alert = _styledComponents2.default.div.withConfig({
  displayName: 'UIHeader__Alert'
})(['margin-top:20px;margin-bottom:', ';'], function (_ref6) {
  var tabs = _ref6.tabs;
  return tabs && '20px';
});

var Toolbar = (0, _styledComponents2.default)(_UIButtonWrapper2.default).attrs({ justify: 'end' }).withConfig({
  displayName: 'UIHeader__Toolbar'
})(['flex-grow:1;margin-left:auto;']);

var renderTitle = function renderTitle(title, badge) {
  if (!badge) return title;

  var badgeOutput = (0, _react.cloneElement)(badge, {
    className: (0, _classnames2.default)(badge.props.className, 'private-header__badge')
  });

  return _react2.default.createElement(
    'span',
    { className: 'private-header__title__inner' },
    title,
    badgeOutput
  );
};

var renderHeading = function renderHeading(badge, children, headingLevel, title, titleControls) {
  var titleControlsWrapper = titleControls && _react2.default.createElement(
    'div',
    { className: 'private-header__title-badge' },
    titleControls
  );

  var titleWrapperClassName = (0, _classnames2.default)('private-header__title', {
    'private-page__title': headingLevel === 'h1'
  });

  var Heading = headingLevel;

  return _react2.default.createElement(
    'div',
    { className: titleWrapperClassName },
    _react2.default.createElement(
      Heading,
      {
        className: (0, _classnames2.default)('private-header__heading', {
          'private-header__heading--solo': !children && !titleControls
        })
      },
      renderTitle(title, badge)
    ),
    titleControlsWrapper
  );
};

var renderToolbar = function renderToolbar(children) {
  return children && _react2.default.createElement(
    Toolbar,
    { className: 'private-header__toolbar' },
    children
  );
};

/**
 * Standard page title which allows CTAs, filters, etc.
 */
function UIHeader(props) {
  var alert = props.alert,
      badge = props.badge,
      breadcrumbs = props.breadcrumbs,
      children = props.children,
      className = props.className,
      details = props.details,
      flush = props.flush,
      fullWidth = props.fullWidth,
      headingLevel = props.headingLevel,
      role = props.role,
      tabs = props.tabs,
      title = props.title,
      titleControls = props.titleControls,
      use = props.use,
      rest = _objectWithoutProperties(props, ['alert', 'badge', 'breadcrumbs', 'children', 'className', 'details', 'flush', 'fullWidth', 'headingLevel', 'role', 'tabs', 'title', 'titleControls', 'use']);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      widthConstrained = _useState2[0],
      setWidthConstrained = _useState2[1];

  var headerRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    var measureWidth = function measureWidth() {
      var headerEl = (0, _reactDom.findDOMNode)(headerRef.current);
      var titleEl = headerEl.querySelector('.private-header__title');
      if (!titleEl) return;

      // Measure width without the width-constrained class
      var hasWidthConstrainedClass = headerEl.classList.contains('private-header--width-constrained');
      if (hasWidthConstrainedClass) {
        headerEl.classList.remove('private-header--width-constrained');
      }
      var newWidthConstrained = titleEl.clientWidth < CONSTRAINED_TITLE_WIDTH;
      if (hasWidthConstrainedClass) {
        headerEl.classList.add('private-header--width-constrained');
      }

      setWidthConstrained(newWidthConstrained);
    };

    measureWidth();
    addEventListener('resize', measureWidth);
    return function () {
      removeEventListener('resize', measureWidth);
    };
  }, []);

  var classes = (0, _classnames2.default)('private-header', className, {
    'private-header--full-width': fullWidth,
    'private-header--flush': flush,
    'private-header--with-details': details,
    'private-header--with-tabs': tabs,
    'private-header--width-constrained': widthConstrained
  });

  return _react2.default.createElement(
    Outer,
    _extends({
      className: classes,
      ref: headerRef,
      role: 'presentation',
      breadcrumbs: breadcrumbs,
      condensed: use === 'condensed',
      fullWidth: fullWidth,
      tabs: tabs
    }, rest),
    breadcrumbs,
    _react2.default.createElement(
      Inner,
      { className: 'private-header__inner', role: role, tabs: tabs },
      title && renderHeading(badge, children, headingLevel, title, titleControls),
      renderToolbar(children)
    ),
    details,
    alert && _react2.default.createElement(
      Alert,
      { tabs: tabs },
      alert
    ),
    tabs
  );
}

UIHeader.propTypes = {
  alert: _propTypes2.default.node,
  breadcrumbs: _propTypes2.default.node,
  badge: _propTypes2.default.node,
  children: _propTypes2.default.node,
  details: _propTypes2.default.node,
  flush: _propTypes2.default.bool.isRequired,
  fullWidth: _propTypes2.default.bool.isRequired,
  headingLevel: _propTypes2.default.oneOf(_HeadingConstants.HEADING_SIZES),
  tabs: _propTypes2.default.node,
  title: _propTypes2.default.node,
  titleControls: _propTypes2.default.node,
  use: _propTypes2.default.oneOf(['condensed'])
};

UIHeader.defaultProps = {
  flush: false, // for backwards compat, this will be true in next major version
  fullWidth: true,
  headingLevel: 'h1',
  role: 'banner'
};

UIHeader.displayName = 'UIHeader';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/layout/UIHeader.js
// module id = 127
// module chunks = 177